import { useHistory } from 'react-router';
import * as React from 'react';

// @ts-ignore
import * as getFormData from 'get-form-data';
import { parse, stringify } from 'query-string';

export interface FormProps {
  method?: string;
  noValidate: boolean;
  className?: string;
  onSubmit: (event: any) => void;
  handleChange?: (event: any) => void;
  dispatchEvent?: (event: any) => void;
  replace?: boolean;
  acceptCharset?: string;
  action?: string;
  autoComplete?: string;
  encType?: string;
  name?: string;
  target?: string;
  wrappedFormRef?: (ref: any) => void;
  'data-stid'?: string;
  children?: any;
}

export function Form({ handleChange, onSubmit, replace, wrappedFormRef, 'data-stid': dataStid, children, ...validFormData }: FormProps) {
  const history = useHistory();

  const handleFormChange = (evt: any) => {
    if (typeof handleChange === 'function') {
      handleChange(evt);
    }
  };

  const handleSubmit = (evt: any) => {
    onSubmitOverride(evt, onSubmit, replace);
  };

  const onSubmitOverride = (
    event: { target: any; defaultPrevented: any; preventDefault: () => void },
    onSubmit: { (event: any): void; (arg0: any, arg1: any): void },
    replace: boolean | undefined
  ) => {
    const { action } = validFormData;
    const formData = getFormData(event.target);

    ensureCorrectTypes(formData);

    if (onSubmit) {
      onSubmit(event, formData);
    }

    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();

    const queryString = stringify(formData);
    const queryParams = parse(history.location.search);
    const pwaOverlay = queryParams.pwaOverlay ? `&pwaOverlay=${queryParams.pwaOverlay}` : '';
    const submitUrl = `${action}?${queryString}${pwaOverlay}`;

    if (replace) {
      history.replace(submitUrl);
    } else {
      history.push(submitUrl);
    }
  };

  /*
    Fix known issue with get-form-data 1.2.5 library where hidden fields for element with multiple same-named inputs
    gets changed into an array. https://unpkg.com/browse/get-form-data@1.2.4/lib/index.js#L108
    Since we have all form elements defined as hidden type between the search-form and sort/filter form we run into this
    issue for radio button type elements.
  */
  const ensureCorrectTypes = (formData: { [x: string]: any[] }) => {
    const elementsToCorrect = [{ key: 'infantsInSeats' }];
    elementsToCorrect.forEach(({ key }) => {
      const elements = formData[key];
      if (Array.isArray(elements)) {
        formData[key] = formData[key][0];
      }
    });
  };

  return (
    <form {...validFormData} onChange={handleFormChange} onSubmit={handleSubmit} ref={wrappedFormRef} data-stid={dataStid}>
      {children}
    </form>
  );
}

Form.displayName = 'Form';
